import { Injectable } from '@angular/core';
import { DefaultService, PowerSupplyLogHistory } from '@psnb/psnb-api';
import { map } from 'rxjs/operators';
import { observable, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class PowerSupplyService {
  powerSupply: any = {};

  constructor(private powerSupplyService: DefaultService,private http:HttpClient) {
  }

  getInputSurgeArrestorsService() {
    return this.powerSupplyService.getInputSurgeArrestors().pipe(map(res => res));
  }

  getOutputSurgeArrestorsService() {
    return this.powerSupplyService.getOutputSurgeArrestors().pipe(map(res => res));
  }

  getTransponderModelService() {
    return this.powerSupplyService.getTransponderModels().pipe(map(res => res));
  }

  getTransponderVendorService() {
    return this.powerSupplyService.getTransponderVendors().pipe(map(res => res));
  }

  // getControllerCardTypesService() {
  //   return this.powerSupplyService.getControllerCardTypes().pipe(map(res => res));
  // }

  getPowerSupplyModelsService() {
    return this.powerSupplyService.getPowerSupplyModels().pipe(map(res => res));
  }

  getBatteryTypesService() {
    return this.powerSupplyService.getBatteryTypes().pipe(map(res => res));
  }

  getBatteryBalancersService() {
    return this.powerSupplyService.getBatteryBalancers().pipe(map(res => res));
  }

  getPowerSupplyVendorsService() {
    return this.powerSupplyService.getPowerSupplyVendors().pipe(map(res => res));
  }

  getEstimatedDesignRuntimesService() {
    return this.powerSupplyService.getEstimatedDesignRuntimes().pipe(map(res => res));
  }

  getStateService() {
    this.powerSupplyService.getStates().pipe(map(res => res));
  }

  getRegionsList() {
    return this.powerSupplyService.getRegions().pipe(map(res => res));
  }

  getPowerSupplyReviewHistory(path) {
    return this.powerSupplyService.getPSHistory(path).pipe(map(res => res));
  }

  getPSHistoryByPreference(nodeId) {
    return this.powerSupplyService.getPSHistoryByPreference(nodeId).pipe(map(res => res));
  }

  advanceSearchByPowerSupplyName(data) {
    return this.powerSupplyService.advanceSearchByPowerSupplyName(data).pipe(map(res => res));
  }

  advanceSearchByHeadendOrTown(data) {
    return this.powerSupplyService.advanceSearchByHeadendOrTown(data).pipe(map(res => res));
  }

  advancePowerSupplyMacSearch(data) {
    return this.powerSupplyService.advancePowerSupplyMacSearch(data).pipe(map(res => res));
  }

  advancePowerSupplyPSID(data) {
    return this.powerSupplyService.advanceSearchByPowerSupplyId(data).pipe(map(res => res));
  }

  advanceSearchByAddress(data) {
    return this.powerSupplyService.advanceSearchByAddress(data).pipe(map(res => res));
  }

  getPowerSupplyById(powerSupplyId) {
    return this.powerSupplyService.getPowerSupplyById(powerSupplyId).pipe(map(res => res));
  }

  getPSNameAndRegion(nodeId) {
    return this.powerSupplyService.getPSNameAndRegion(nodeId).pipe(map(res => res));
  }


  getNWTTeams(nodeName,state) {
    return this.powerSupplyService.getNWTTeams(nodeName,state).pipe(map(res => res));

  }

  getNWTTeamsList(nodeId) {
    return this.powerSupplyService.getNWTTeamsList(nodeId).pipe(map(res => res));

  }

  getPSStatusLink(macAddress) {
    return this.powerSupplyService.getPSStatusLink(macAddress).pipe(map(res => res));
  }

  getPSLogHistoryByPSId(powerSupplyId): Observable<PowerSupplyLogHistory[]> {
    return this.powerSupplyService.getPSLogHistoryByPSId(powerSupplyId).pipe(map(res => res));
  }

  getPowerSupplyByMAC(macAddress) {
    return this.powerSupplyService.getPowerSupplyByMAC(macAddress).pipe(map(res => res));
  }

  getStates() {
    return this.powerSupplyService.getStates().pipe(map(res => res));
  }

  getStatesByRootId(regionId) {
    return this.powerSupplyService.getStatesByRootId(regionId).pipe(map(res => res));
  }

  movePowerSupply(movePSs) {
    return this.powerSupplyService.movePowerSupply(movePSs).pipe(map(res => res));
  }

  pullTransponder(ip) {
    return this.powerSupplyService.pullTransponder(ip).pipe(map(res => res));
  }

  pullTransponderByMacAddress(macAddress) {
    return this.powerSupplyService.getPowerSupplyTelemetryHourlyData(macAddress).pipe(map(res => res));
  }

  generateMacAddress(region) {
    return this.powerSupplyService.generateMacAddress(region).pipe(map(res => res));
  }

  validateMacPlaceholder(macAddress) {
    return this.powerSupplyService.validateMacPlaceholder(macAddress).pipe(map(res => res));
  }

  generateIpAddress(ip) {
    return this.powerSupplyService.generateIpAddress(ip).pipe(map(res => res));
  }

  getApuByPowerSupplyId(powerSupplyId) {
    return this.powerSupplyService.getApuByPowerSupplyId(powerSupplyId).pipe(map(res => res));
  }

  getPowerSupplyCpnByPowerSupplyId(powerSupplyId, supplyNumber) {
    return this.powerSupplyService.getPowerSupplyCpnByPowerSupplyId(powerSupplyId, supplyNumber).pipe(map(res => res));
  }

  getPowerSupplySfpTriageByPsId(powerSupplyId,triageId){
    return this.powerSupplyService.getPowerSupplySfpTriageByPsId(powerSupplyId,triageId).pipe(map(res => res));
  }

  getPowerSupplySfpTriage(triageId){
    return this.powerSupplyService.getPowerSupplySfpTriage(triageId).pipe(map(res => res));
  }
  savePowerSupplySfpTriageToMaster(sfp){
    return this.powerSupplyService.savePowerSupplySfpTriageToMaster(sfp).pipe(map(res => res));
  }
  getPowerSupplySfpByPowerSupplyId(powerSupplyId) {
    return this.powerSupplyService.getPowerSupplySfpByPowerSupplyId(powerSupplyId).pipe(map(res => res));
  }

  getHeadends(path) {
    return this.powerSupplyService.getNetworkHeadEnd(path).pipe(map(res => res));
  }

  getCommunities(path) {
    return this.powerSupplyService.getCommunities(path).pipe(map(res => res));
  }

  getCommunitiesByHubId(ncphubId, path) {
    return this.powerSupplyService.getCommunitiesByHubId(path, ncphubId).pipe(map(res => res));
  }

  savePowerSupplySfpTriage(powerSupplySfp) {
    return this.powerSupplyService.savePowerSupplySfpTriage(powerSupplySfp).pipe(map(res => res));
  }

  updatePowerSupplySfpTriage(powerSupplySfp) {
    return this.powerSupplyService.updatePowerSupplySfpTriage(powerSupplySfp).pipe(map(res => res));
  }

  createPowerSupplySfp(powerSupplySfp) {
    return this.powerSupplyService.createPowerSupplySfp(powerSupplySfp).pipe(map(res => res));
  }

  updatePowerSupplySfp(powerSupplySfp) {
    return this.powerSupplyService.updatePowerSupplySfp(powerSupplySfp).pipe(map(res => res));
  }

  createPowerSupplyCpn(powerSupplyCpn2) {
    return this.powerSupplyService.createPowerSupplyCpn(powerSupplyCpn2).pipe(map(res => res));
  }

  updatePowerSupplyCpn(powerSupplyCpn2) {
    return this.powerSupplyService.updatePowerSupplyCpn(powerSupplyCpn2).pipe(map(res => res));
  }

  getApuVisitByPowerSupplyId(powerSupplyId) {
    return this.powerSupplyService.getApuVisitByPowerSupplyId(powerSupplyId).pipe(map(res => res));
  }

  createApuVisit(apuVisitObj) {
    return this.powerSupplyService.createApuVisit(apuVisitObj).pipe(map(res => res));
  }

  updateApuVisit(apuVisitObj) {
    return this.powerSupplyService.updateApuVisit(apuVisitObj).pipe(map(res => res));
  }

  createApu(apuObj) {
    return this.powerSupplyService.createApu(apuObj).pipe(map(res => res));
  }

  updateApu(apuObj) {
    return this.powerSupplyService.updateApu(apuObj).pipe(map(res => res));
  }

  saveTriageAPUCertificate(apuObj) {
    return this.powerSupplyService.saveTriageAPUCertificate(apuObj).pipe(map(res => res));
  }

  saveTriageAPUShowVisitCertificate(apuObj) {
    return this.powerSupplyService.saveTriageAPUShowVisitCertificate(apuObj).pipe(map(res => res));
  }


  savePowerSupply(powerSupply) {
    return this.powerSupplyService.savePowerSupply(powerSupply).pipe(map(res => res));
  }

  savePSCertificate(powerSupply) {
    return this.powerSupplyService.savePSCertificate(powerSupply).pipe(map(res => res));
  }
  saveWorkItemData(model) {
    return this.powerSupplyService.saveWorkItem(model).pipe(map(res => res));
  }
  editWorkItemData(model) {
    return this.powerSupplyService.editWorkItem(model).pipe(map(res => res));
  }
  getWorkItemsByPowerSupplyId(powerSupplyId, psCertificationId) {
    return this.powerSupplyService.getWorkItems(powerSupplyId, psCertificationId).pipe(map(res => res));
  }
  deleteControllerWorkItem(id: number) {
    return this.powerSupplyService.deleteWorkItem(id).pipe(map(result => result));
  }
  createPowerSupply(powerSupply) {
    return this.powerSupplyService.createPowerSupply(powerSupply).pipe(map(res => res));
  }

  isAdmin() {
    return this.powerSupplyService.isAdmin().pipe(map(res => res));
  }

  isXOCAdmin() {
    return this.powerSupplyService.isXOCAdmin().pipe(map(res => res));
  }

  changePSStatusInProgress(psChangeStatus) {
    return new Observable<{ success: true }>(observer => {
    });
  }

  changePSStatusCompleted(psChangeStatus) {
    return new Observable<{ success: true }>(observer => {
    });
  }

  changePSStatusCancel(psChangeStatus) {
    return new Observable<{ success: true }>(observer => {
    });
  }

  changePSStatusRejected(email, psChangeStatus) {
    return new Observable<{ success: true }>(observer => {
    });
  }
  uploadImage(triageId, filearray, ImagevaluesBlob) {
    return this.powerSupplyService.uploadImage(triageId, filearray, ImagevaluesBlob).pipe(map(res => res));
  }

  getPsnbImageDetailByPsId(powerSupplyId) {
    return this.powerSupplyService.getPsnbImageDetailByPsId(powerSupplyId).pipe(map(res => res));
  }

  getPsnbImageByPsId(powerSupplyId, imageName) {
    return this.powerSupplyService.getPsnbImageByPsId(powerSupplyId, imageName).pipe(map(res => res));
  }

  getPsnbtriageImageByPsId(triageId, category) {
    return this.powerSupplyService.getTriageImageByCategory(triageId, category).pipe(map(res => res));
  }

  uploadSdsImage(actionType, triageId, filearray, ImagevaluesBlob) {
    return this.powerSupplyService.uploadSdsImage(actionType, triageId, filearray, ImagevaluesBlob).pipe(map(res => res));
  }

  getPsnbSdsImageDetailByPsId(powerSupplyId) {
    return this.powerSupplyService.getPsnbSdsImageDetailByPsId(powerSupplyId).pipe(map(res => res));
  }

  getPsnbSdsImageByPsIdAndCategory(powerSupplyId, category) {
    return this.powerSupplyService.getPsnbSdsImageByPsIdAndCategory(powerSupplyId, category).pipe(map(res => res));
  }

  getPsnbSdsTriageImageByCategoryAndTriageId(triageId, category) {
    return this.powerSupplyService.getPsnbSdsTriageImageByPSIdAndCategoryAndTriageId(triageId, category).pipe(map(res => res));
  }


  createPowerSupplyForNonComcastUsers(powerSupply) {
    return this.powerSupplyService.createPowerSupplyForNonComcastUsers(powerSupply).pipe(map(res => res));
  }

  editPowerSupplyForNonComcastUsers(powerSupply) {
    return this.powerSupplyService.savePowerSupplyForNonComcastUsers(powerSupply).pipe(map(res => res));
  }

  getPowerSupplyByPsId(powersupplyId) {
    return this.powerSupplyService.getPSTriageByPsId(powersupplyId).pipe(map(res => res));
  }

  getPowerSupplyTelemetryData(macaddress,powerSupplyId) {
    return this.powerSupplyService.getPowerSupplyTelemetryData(macaddress,powerSupplyId).pipe(map(res => res));
  }
  getTelemetryThresholds(macaddress) {
    return this.powerSupplyService.getTelemetryThresholds(macaddress).pipe(map(res => res));
  }
  getPowerSuppliesFailedTestReports(hierarchyId) {
    return this.powerSupplyService.getPSAllTests(hierarchyId).pipe(map(res => res));
  }

  getPsnbSdsPDFImageByPsId(psId){
    return this.powerSupplyService.getPsnbSdsPDFImageByPsId(psId).pipe(map(res => res));
  }

  setTestDurationByIP(ip,testDuration){
    return this.powerSupplyService.setTestDurationByIP(ip,testDuration).pipe(map(res => res));
  }

  setTestDurationByMac(macAddress,testDuration){
    return this.powerSupplyService.setTestDurationByMac(macAddress,testDuration).pipe(map(res => res));
  }

  getPowerSupplyTelemetryHistory(telemetryHistoryRequest){
    return this.powerSupplyService.getPowerSupplyTelemetryHistory(telemetryHistoryRequest).pipe(map(res => res));
  }

  updatePSIDAndTriageIDByMacAndCategory(request){
    return this.powerSupplyService.updatePSIDAndTriageIDByMacAndCategory(request).pipe(map(res => res));
  }
  getPSCertificationAll(powersupplyId,certId) {
    return this.powerSupplyService.getPSCertifications(powersupplyId,certId).pipe(map(res => res));
  }


  getPSCertificationID(powersupplyId,inspectionDate) {
    return this.powerSupplyService.getPSCertificationID(powersupplyId,inspectionDate).pipe(map(res => res));
  }

  getPSCertifications(powersupplyId,certId) {
    return this.powerSupplyService.getPSCertifications(powersupplyId,certId).pipe(map(res => res));
  }

  getTelemetryThresholdsAlertProfile() {
    return this.powerSupplyService.getTelemetryThresholdsAlertProfile().pipe(map(res => res));
  }

  getTriageWorkItemsBYPsCertID(certId,psId, triageId) {
    return this.powerSupplyService.getTriageWorkItemsBYPsCertID(certId,psId, triageId).pipe(map(res => res));
  }
  getTriageWorkItems(triageId) {
    return this.powerSupplyService.getTriageWorkItems(triageId).pipe(map(res => res));
  }
  getPSCertDeltaDetails(triageId) {
    return this.powerSupplyService.getPSCertDeltaDetails(triageId).pipe(map(res => res));
  }
  saveTriageWorkItem(model) {
    return this.powerSupplyService.saveTriageWorkItem(model).pipe(map(res => res));
  }
  editTriageWorkItem(model) {
    return this.powerSupplyService.editTriageWorkItem(model).pipe(map(res => res));
  }

  editTriageMaterial(model) {
    return this.powerSupplyService.editTriageMaterialItem(model).pipe(map(res => res));
  }

  deleteTriageWorkItem(id) {
    return this.powerSupplyService.deleteTriageWorkItem(id).pipe(map(res => res));
  }
  updateTriageIDWorkItem(model) {
    return this.powerSupplyService.updateTriageIDWorkItem(model).pipe(map(res => res));
  }

  updateTriageMaterialItem(model) {
    return this.powerSupplyService.updateTriageIDMaterialItem(model).pipe(map(res => res));
  }

  saveTriageWorkItemToMaster(workItems) {
    return this.powerSupplyService.saveTriageWorkItemToMaster(workItems).pipe(map(res => res));
  }

  saveTriageMaterialItemToMaster(materialItems) {
    return this.powerSupplyService.saveTriageMaterialItemToMaster(materialItems).pipe(map(res => res));
  }

  getWorkItemsByPsId(id) {
    return this.powerSupplyService.getWorkItemsByPsId(id).pipe(map(res => res));
  }

  getRealTimeRmodeStatus(mac) {
    return this.powerSupplyService.getRealTimeRmodeStatus(mac).pipe(map(res => res));
  }

  getCommunitiesbpticket(nodeId) {
    return this.powerSupplyService.getCommunitiesbpticket(nodeId).pipe(map(res => res));
  }

  getHeadends1(nodeId) {
    return this.powerSupplyService.getHeadends(nodeId).pipe(map(res => res));
  }

  getFilteredPsForTicketing(pSFilteredRequest) {
    return this.powerSupplyService.getFilteredPsForTicketing(pSFilteredRequest).pipe(map(res => res));
  }

  getFilteredPsForBatteryHealthTicketing(pSFilteredRequest) {
    return this.powerSupplyService.getFilteredPsForBatteryHealthTicketing(pSFilteredRequest).pipe(map(res => res));
  }

  getEqTransponderVendorsName() {
    return this.powerSupplyService.getEqTransponderVendorsName().pipe(map(res => res));
  }
  getEqTransponderModelsName() {
    return this.powerSupplyService.getEqTransponderModelsName().pipe(map(res => res));
  }

  getHierarchyPreferences(){
    return this.powerSupplyService.getHierarchyPreferences().pipe(map(res => res));
  }

  saveHierarchyPreferences(psnbHierarchyLocationPreferencesModel){
    return this.powerSupplyService.saveHierarchyPreferences(psnbHierarchyLocationPreferencesModel).pipe(map(res => res));
  }

  updateHierarchyPreferences(psnbHierarchyLocationPreferencesModel){
    return this.powerSupplyService.updateHierarchyPreferences(psnbHierarchyLocationPreferencesModel).pipe(map(res => res));
  }


  deleteHierarchyPreferences(id){
    return this.powerSupplyService.deleteHierarchyPreferences(id).pipe(map(res => res));
  }

  getStandByOptionsByState(state) {
    return this.powerSupplyService.getStandByOptions(state).pipe(map(res => res));
  }

  getPowerHouseByPsId(powerSupplyId){
    return this.powerSupplyService.getPowerHouseByPsId(powerSupplyId).pipe(map(res => res));
  }

  getStormOutputCurrent(stormTelemetryHistoryRequest){
    return this.powerSupplyService.getStormOutputCurrent(stormTelemetryHistoryRequest).pipe(map(res => res));
  }

  saveMaterialItem(model){
    return this.powerSupplyService.saveMaterialItem(model).pipe(map(result => result));
  }
  getMaterialItemsByPs(powerSupplyId){
    return this.powerSupplyService.getMaterialItemsByPsId(powerSupplyId).pipe(map(res => res));

  }

  getMaterialItemsByPsId(powerSupplyId, psCertificationId) {
    return this.powerSupplyService.getMaterialItems(powerSupplyId, psCertificationId).pipe(map(res => res));
  }

  deleteControllerMaterial(id: number) {
    return this.powerSupplyService.deleteMaterialItem(id).pipe(map(result => result));
  }

  editMaterialItem(model) {
    return this.powerSupplyService.editMaterialItem(model).pipe(map(res => res));
  }

  saveTriageMaterialItem(model){
    return this.powerSupplyService.saveTriageMaterialItem(model).pipe(map(result => result));
  }

  getTriageMaterialItemsBYPsCertID(certId,psId, triageId) {
    return this.powerSupplyService.getTriageMaterialItemsBYPsCertID(certId,psId, triageId).pipe(map(res => res));
  }

  getTriageMaterialItems(triageId) {
    return this.powerSupplyService.getTriageMaterialItems(triageId).pipe(map(res => res));
  }

  deleteTriageMaterialItem(id) {
    return this.powerSupplyService.deleteTriageMaterialItem(id).pipe(map(res => res));
  }
}
